import { LuxButton, SectionHeading } from "../common/Primitives";
import { Reveal, RevealImage } from "../motion/Reveal";
import { Cycle } from "./Cycle";
import { ImpactCertificate } from "./ImpactCertificate";
import { IMG } from "../../config/site";
import { useUI } from "../../context/UIContext";

export const Sustainability = () => {
  const { openPanel } = useUI();
  return (
    <section id="sustainability" data-testid="sustainability-section" className="bg-[#F8F3E9]">
      <div className="mx-auto grid max-w-[1600px] lg:grid-cols-[1fr_1.15fr_0.85fr]">
        <div className="px-5 pb-12 pt-24 sm:px-8 lg:py-32 lg:pl-12 lg:pr-6">
          <SectionHeading eyebrow="Sustainability" lines={["A More Considered", "Way Forward"]} />
          <Reveal delay={0.15}>
            <p className="body-lux mt-8 max-w-md">
              Our returnable-bottle concept is designed to support a more considered approach to hospitality packaging. Through agreed
              collection, professional washing, inspection, and refilling processes, we aim to help partners reduce reliance on single-use
              packaging where operationally appropriate.
            </p>
            <LuxButton variant="line-dark" arrow className="mt-10" onClick={() => openPanel("sustain")} data-testid="sustainability-approach-btn">Our sustainability approach</LuxButton>
          </Reveal>
        </div>
        <div className="px-5 py-16 sm:px-8 lg:px-10 lg:py-32">
          <Cycle />
        </div>
        <div className="relative min-h-[420px] lg:min-h-0">
          <RevealImage src={IMG.greenery} alt="Sunlight filtering through fresh green leaves" className="absolute inset-0" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#21170F]/75 via-[#21170F]/20 to-transparent" />
          <p className="font-serif-lux absolute bottom-10 left-8 right-8 text-[1.9rem] italic leading-snug text-[#F8F3E9]">
            Exceptional hospitality can also be a more considered choice.
          </p>
        </div>
      </div>
      <ImpactCertificate />
    </section>
  );
};
